import { Box } from "@mui/material";
import { ActivityDetails } from "./ActivityDetails";
import { ModelDetails } from "./ModelDetails";
import { RelatedModels } from "./RelatedModels";
export const ModelInfo = () => {
  return <Box px={4} py={2} sx={{
    overflowY: "auto"
  }} data-sentry-element="Box" data-sentry-component="ModelInfo" data-sentry-source-file="index.tsx">
      <Box display="flex" flexDirection={"column"} gap={4} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <ModelDetails data-sentry-element="ModelDetails" data-sentry-source-file="index.tsx" />
        <RelatedModels data-sentry-element="RelatedModels" data-sentry-source-file="index.tsx" />
        <ActivityDetails data-sentry-element="ActivityDetails" data-sentry-source-file="index.tsx" />
      </Box>
    </Box>;
};